const customButton = {
  fontSize: "16px",
  fontWeight: "bold",
  color: "#ffffff",
  background: "#990000",
  height: "40px",
  display: "inline-flex",
  boxSizing: "border-box",
  justifyContent: "center",
  px: "9px",
  willChange: "box-shadow, transform",
  boxShadow: "0px 0.01em 0.01em rgba(45, 35, 66, 0.4), 0px 0.3em 0.7em -0.01em rgba(45, 35, 66, 0.3), inset 0px -0.01em 0px rgba(58, 65, 111, 0.5)",
  borderRadius: "7px",
  textDecoration: "none",
  textShadow: "0 1px 0 rgba(0, 0, 0, 0.4)",
  transition: "box-shadow 0.15s ease, transform 0.15s ease",
  whiteSpace: "nowrap",
  "&:hover": {
    boxShadow: "0px 0.1em 0.2em grey, 0px 0.4em 0.7em -0.1em grey, inset 0px -0.1em 0px #990000",
    transform: "translateY(-0.1em)",
    backgroundColor: "#990000",
  },
  "&:active": {
    boxShadow: "inset 0px 0.1em 0.6em #990000",
    transform: "translateY(0em)",
  },
};

export default customButton;
